import { render, staticRenderFns } from "./BookingSummarySectionOne.vue?vue&type=template&id=2f4de5e5"
import script from "./BookingSummarySectionOne.vue?vue&type=script&lang=js"
export * from "./BookingSummarySectionOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports